module.exports = __webpack_public_path__ + "static/media/back_page_sample.dadcf9d0.png";